import React from "react";
import { Helmet } from "react-helmet-async";

const UnauthorizedHeadContent = () => {

  return (
    <Helmet>
      <meta name="description" content="Devis" />
      <meta name="author" content="Cubotoo" />
      <meta name="keyword" content="Cubotoo, tender, devis" />
      <link rel="shortcut icon" href={`${ window.location.href.toLowerCase().includes("demo") ? "/cubotoo-logo.png" : "/favicon.ico" }`} />
      <title>{`${ window.location.href.toLowerCase().includes("demo") ? "cubotoo Devis Platform" : "Devis@HGC" }`}</title>
    </Helmet>
  );
};

export default UnauthorizedHeadContent;
